import React from "react";
import { Input } from "reactstrap";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import { Field, Symbol, Combobox } from "../Order/Field/Field";
import Autosuggest from "../../Autosuggest/Autosuggest";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { ProductType, getProductTypeName } from "../../../utils/Order/Order";
import style from "./Trading.module.scss";

export const NumberField = ({
  value,
  label,
  disabled,
  error,
  onChange,
  style,
  tabIndex = "2",
  placeholder,
  dataTypeDecimalName,
  decimalScale,
}) => (
  <Field label={label} error={error} style={style || {}}>
    <NumberFormatInput
      type="text"
      tabIndex={tabIndex}
      customInput={Input}
      value={value || ""}
      disabled={disabled}
      invalid={!!error}
      onValueChange={(e) => onChange(e.value)}
      decimalScale={decimalScale}
      dataTypeDecimalName={dataTypeDecimalName}
      placeholder={placeholder || label}
    />
  </Field>
);

export const DateTimeField = ({
  value,
  label,
  disabled,
  error,
  onChange,
  style,
  inputStyle,
  tabIndex = "3",
  step = "60",
}) => (
  <Field label={label} error={error} style={style || {}}>
    <Input
      tabIndex={tabIndex}
      type="datetime-local"
      step={step}
      placeholder={label}
      disabled={disabled}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      style={inputStyle}
    />
  </Field>
);

export const CounterpartySuggest = ({ value, error, disabled, fetchItems, onChange, style = {} }) => (
  <Field label={"Counterparty"} error={error}>
    <Autosuggest
      renderSuggestion={renderSuggestion}
      getSuggestionValue={(suggestion) => `${suggestion.name}`}
      onSuggestionsFetchRequested={({ value }) => fetchItems(value)}
      value={value || ""}
      inputProps={{
        placeholder: "Counterparty",
        invalid: !!error,
        disabled,
      }}
      onChange={(m, v) => onChangeCparty(m, v, onChange)}
      style={style || {}}
    />
  </Field>
);

export const SymbolField = ({ error, label, disabled, onChange, value, form, services }) => (
  <Field label={label} error={error}>
    <Symbol
      form={form}
      onChange={onChange}
      placeholder={label}
      invalid={!!error}
      value={value.name}
      description={value.description}
      provider={null}
      readonly={disabled}
      disabled={disabled}
      attrId={"id"}
      attrTicker={"name"}
      attrDescription={"description"}
      searchSymbol={services.fetchSearchSymbol}
      hideButtonOptn
      hideInfo
    />
  </Field>
);

export const ProductField = ({ form, onChange, disabled, style }) => (
  <Field label={"Product"} style={style || {}}>
    <Combobox
      style={{ background: "#607d8b", color: "#fff", fontWeight: 500 }}
      value={form}
      disabled={disabled}
      onChange={(v) => onChange("form", { value: v })}
      items={Object.values(ProductType).map((key, index) => ({
        id: key,
        description: getProductTypeName(key),
      }))}
    />
  </Field>
);

export const TradingRoutes = ({ error, disabled, value, onChange, tradeRoutes, style = {} }, autoWidth) => (
  <Field label={"Trading routes"} error={error} style={style}>
    {tradeRoutes == null ? (
      <CircularProgress sm style={{ margin: "5px auto" }} />
    ) : (
      <Combobox
        emptyLabel={"Route"}
        value={value}
        disabled={disabled}
        invalid={!!error}
        onChange={(v) => onChange(v)}
        items={tradeRoutes}
        style={autoWidth ? {} : { minWidth: "170px" }}
      />
    )}
  </Field>
);

const onChangeCparty = (method, value, onChange) => {
  let _value = {
    counterpartyId: null,
    counterpartyName: "",
  };

  if (method != "type" && value.id) {
    _value = {
      counterpartyId: value.id,
      counterpartyName: value.name,
    };
  }

  onChange(_value);
};

export const fetchCParties = (value, counterparties) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return new Promise((resolve, rej) => {
    resolve(
      inputLength === 0
        ? []
        : Object.entries(counterparties)
            .filter((cp) => cp[1].Value.toLowerCase().includes(inputValue))
            .map((cp) => ({ id: cp[1].Id, name: cp[1].Value }))
    );
  });
};

const renderSuggestion = (suggestion) => (
  <div className={style.suggestionItem}>
    <span>{suggestion.name}</span>
  </div>
);
